var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardbg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Degradado_sin_nombre_87-2);\n        filter: url(#drop-shadow-7);\n      }\n\n      .cls-2 {\n        fill: url(#Degradado_sin_nombre_88-4);\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19 {\n        opacity: .2;\n      }\n\n      .cls-3 {\n        stroke: url(#Degradado_sin_nombre_88-28);\n      }\n\n      .cls-3, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-17, .cls-27, .cls-18 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-28 {\n        fill: url(#Degradado_sin_nombre_87-5);\n        filter: url(#drop-shadow-14);\n      }\n\n      .cls-29 {\n        fill: url(#Degradado_sin_nombre_88-48);\n      }\n\n      .cls-20 {\n        filter: url(#drop-shadow-3);\n      }\n\n      .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27 {\n        stroke: #f9a61a;\n      }\n\n      .cls-20, .cls-23, .cls-26, .cls-27 {\n        stroke-width: 2px;\n      }\n\n      .cls-4 {\n        fill: url(#Degradado_sin_nombre_88-2);\n      }\n\n      .cls-30 {\n        fill: url(#Degradado_sin_nombre_88-13);\n        filter: url(#drop-shadow-5);\n      }\n\n      .cls-31 {\n        fill: url(#Degradado_sin_nombre_88-47);\n      }\n\n      .cls-32 {\n        fill: #f9a61a;\n      }\n\n      .cls-33 {\n        fill: url(#Degradado_sin_nombre_88-14);\n      }\n\n      .cls-5 {\n        fill: url(#Degradado_sin_nombre_88-31);\n      }\n\n      .cls-34 {\n        fill: url(#Degradado_sin_nombre_88-44);\n      }\n\n      .cls-6 {\n        fill: url(#Degradado_sin_nombre_88-26);\n      }\n\n      .cls-35 {\n        fill: url(#Degradado_sin_nombre_88-46);\n      }\n\n      .cls-7 {\n        fill: url(#Degradado_sin_nombre_88-36);\n      }\n\n      .cls-8 {\n        fill: url(#Degradado_sin_nombre_88-6);\n      }\n\n      .cls-36 {\n        fill: url(#Degradado_sin_nombre_88-49);\n        filter: url(#drop-shadow-17);\n      }\n\n      .cls-21 {\n        filter: url(#drop-shadow-11);\n        stroke-width: 1.2px;\n      }\n\n      .cls-37 {\n        isolation: isolate;\n      }\n\n      .cls-22, .cls-24 {\n        stroke-width: 1.35px;\n      }\n\n      .cls-38 {\n        fill: url(#Degradado_sin_nombre_88-42);\n      }\n\n      .cls-9 {\n        fill: url(#Degradado_sin_nombre_88-37);\n      }\n\n      .cls-39 {\n        fill: url(#Degradado_sin_nombre_88-38);\n      }\n\n      .cls-40 {\n        fill: url(#Degradado_sin_nombre_87-3);\n        filter: url(#drop-shadow-9);\n      }\n\n      .cls-41 {\n        fill: url(#Degradado_sin_nombre_88-22);\n      }\n\n      .cls-42 {\n        fill: url(#Degradado_sin_nombre_88-15);\n      }\n\n      .cls-23 {\n        filter: url(#drop-shadow-2);\n      }\n\n      .cls-10 {\n        fill: url(#Degradado_sin_nombre_88-5);\n      }\n\n      .cls-43 {\n        fill: url(#Degradado_sin_nombre_88-10);\n        filter: url(#drop-shadow-4);\n      }\n\n      .cls-44 {\n        fill: url(#Degradado_sin_nombre_88-17);\n      }\n\n      .cls-45 {\n        fill: url(#Degradado_sin_nombre_88-45);\n      }\n\n      .cls-46 {\n        fill: url(#Degradado_sin_nombre_88-21);\n      }\n\n      .cls-11 {\n        fill: url(#Degradado_sin_nombre_88-27);\n      }\n\n      .cls-12 {\n        fill: url(#Degradado_sin_nombre_88-33);\n      }\n\n      .cls-47 {\n        fill: url(#Degradado_sin_nombre_88-7);\n      }\n\n      .cls-13 {\n        fill: url(#Degradado_sin_nombre_88);\n      }\n\n      .cls-48 {\n        fill: url(#Degradado_sin_nombre_87-7);\n        filter: url(#drop-shadow-16);\n      }\n\n      .cls-49 {\n        fill: url(#Degradado_sin_nombre_88-41);\n      }\n\n      .cls-14 {\n        fill: url(#Degradado_sin_nombre_88-32);\n      }\n\n      .cls-50 {\n        fill: url(#Degradado_sin_nombre_87-8);\n        filter: url(#drop-shadow-18);\n      }\n\n      .cls-51 {\n        fill: url(#Degradado_sin_nombre_88-9);\n      }\n\n      .cls-24 {\n        filter: url(#drop-shadow-12);\n      }\n\n      .cls-52 {\n        fill: url(#Degradado_sin_nombre_88-19);\n      }\n\n      .cls-25 {\n        stroke-width: .94px;\n      }\n\n      .cls-53 {\n        fill: url(#Degradado_sin_nombre_87-6);\n        filter: url(#drop-shadow-15);\n      }\n\n      .cls-54 {\n        fill: url(#Degradado_sin_nombre_87);\n        filter: url(#drop-shadow-6);\n      }\n\n      .cls-55 {\n        mix-blend-mode: multiply;\n        opacity: .5;\n      }\n\n      .cls-56 {\n        fill: url(#Degradado_sin_nombre_87-4);\n        filter: url(#drop-shadow-10);\n      }\n\n      .cls-26 {\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-57 {\n        opacity: .1;\n      }\n\n      .cls-15 {\n        fill: url(#Degradado_sin_nombre_88-35);\n      }\n\n      .cls-16 {\n        fill: url(#Degradado_sin_nombre_88-34);\n      }\n\n      .cls-58 {\n        fill: url(#Degradado_sin_nombre_88-16);\n      }\n\n      .cls-59 {\n        fill: url(#Degradado_sin_nombre_88-24);\n      }\n\n      .cls-60 {\n        fill: url(#Degradado_sin_nombre_88-43);\n      }\n\n      .cls-61 {\n        fill: url(#Degradado_sin_nombre_88-40);\n        filter: url(#drop-shadow-13);\n      }\n\n      .cls-17 {\n        stroke: url(#Degradado_sin_nombre_88-29);\n      }\n\n      .cls-62 {\n        fill: url(#Degradado_sin_nombre_88-39);\n      }\n\n      .cls-63 {\n        fill: url(#Degradado_sin_nombre_88-18);\n      }\n\n      .cls-64 {\n        fill: url(#Degradado_sin_nombre_88-11);\n      }\n\n      .cls-18 {\n        stroke: url(#Degradado_sin_nombre_88-30);\n      }\n\n      .cls-65 {\n        fill: url(#Degradado_sin_nombre_88-23);\n      }\n\n      .cls-66 {\n        fill: url(#Degradado_sin_nombre_88-20);\n      }\n\n      .cls-67 {\n        fill: url(#Degradado_sin_nombre_88-8);\n      }\n\n      .cls-19 {\n        fill: url(#Degradado_sin_nombre_88-3);\n      }\n\n      .cls-68 {\n        fill: url(#Degradado_sin_nombre_88-25);\n        filter: url(#drop-shadow-8);\n      }\n\n      .cls-69 {\n        fill: url(#Degradado_sin_nombre_88-12);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88",
    "data-name": "Degradado sin nombre 88",
    x1: 217.84,
    y1: 196.66,
    x2: 278.74,
    y2: 196.66,
    gradientTransform: "translate(-66.34 233.17) rotate(-45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf760a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-2",
    "data-name": "Degradado sin nombre 88",
    x1: 254.8,
    y1: 131.53,
    x2: 271.78,
    y2: 131.53,
    gradientTransform: "translate(-15.89 224.7) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-3",
    "data-name": "Degradado sin nombre 88",
    x1: 229.11,
    y1: 58.78,
    x2: 237.97,
    y2: 58.78,
    gradientTransform: "translate(26.83 182.35) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-4",
    "data-name": "Degradado sin nombre 88",
    x1: 218.97,
    y1: 93.03,
    x2: 232.11,
    y2: 93.03,
    gradientTransform: "translate(.27 186.73) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-5",
    "data-name": "Degradado sin nombre 88",
    x1: 298.55,
    y1: 213.03,
    x2: 323.03,
    y2: 213.03,
    gradientTransform: "translate(-59.61 282.16) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-6",
    "data-name": "Degradado sin nombre 88",
    x1: 177.22,
    y1: 78.78,
    x2: 196.36,
    y2: 78.78,
    gradientTransform: "translate(-1 155.16) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-7",
    "data-name": "Degradado sin nombre 88",
    x1: 54.68,
    y1: 263.63,
    x2: 213.6,
    y2: 263.63,
    gradientTransform: "translate(-147.12 172.07) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.33
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-8",
    "data-name": "Degradado sin nombre 88",
    x1: 148.3,
    y1: 41.59,
    x2: 124.3,
    y2: 86.75,
    gradientTransform: "translate(5.92 116.27) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.33
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-9",
    "data-name": "Degradado sin nombre 88",
    x1: 163.16,
    y1: 122.77,
    x2: 217.52,
    y2: 122.77,
    gradientTransform: "translate(-31.06 170.55) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.33
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-10",
    "data-name": "Degradado sin nombre 88",
    x1: 146.63,
    y1: 106.24,
    x2: 171.99,
    y2: 106.24,
    gradientTransform: "translate(-28.46 143.77) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-4",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.33
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-11",
    "data-name": "Degradado sin nombre 88",
    x1: 195.63,
    y1: 155.24,
    x2: 220.99,
    y2: 155.24,
    gradientTransform: "translate(-48.76 192.77) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-12",
    "data-name": "Degradado sin nombre 88",
    x1: 233.12,
    y1: 208.34,
    x2: 249,
    y2: 208.34,
    gradientTransform: "translate(-76.72 231.48) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-13",
    "data-name": "Degradado sin nombre 88",
    x1: 225.52,
    y1: 222.72,
    x2: 256.59,
    y2: 222.72,
    gradientTransform: "translate(-86.88 235.69) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-5",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.33
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-5",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-14",
    "data-name": "Degradado sin nombre 88",
    x1: 226.12,
    y1: 118.92,
    x2: 242,
    y2: 118.92,
    gradientTransform: "translate(-15.53 200.34) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-15",
    "data-name": "Degradado sin nombre 88",
    x1: 184.76,
    y1: 68.83,
    x2: 191.58,
    y2: 68.83,
    gradientTransform: "translate(6.44 153.21) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-16",
    "data-name": "Degradado sin nombre 88",
    x1: 212.15,
    y1: 170.39,
    x2: 218.97,
    y2: 170.39,
    gradientTransform: "translate(-57.35 202.33) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-17",
    "data-name": "Degradado sin nombre 88",
    x1: 260.09,
    y1: 207.75,
    x2: 266.91,
    y2: 207.75,
    gradientTransform: "translate(-69.72 247.17) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-18",
    "data-name": "Degradado sin nombre 88",
    x1: 273.19,
    y1: 157.43,
    x2: 280.01,
    y2: 157.43,
    gradientTransform: "translate(-30.3 241.7) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-19",
    "data-name": "Degradado sin nombre 88",
    x1: 308.4,
    y1: 215.97,
    x2: 315.22,
    y2: 215.97,
    gradientTransform: "translate(-61.39 283.73) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-20",
    "data-name": "Degradado sin nombre 88",
    x1: 344.4,
    y1: 191.97,
    x2: 351.22,
    y2: 191.97,
    gradientTransform: "translate(-33.87 302.16) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-21",
    "data-name": "Degradado sin nombre 88",
    x1: 198.74,
    y1: 52.47,
    x2: 214.62,
    y2: 52.47,
    gradientTransform: "translate(23.43 161.52) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_87",
    "data-name": "Degradado sin nombre 87",
    x1: 209.4,
    y1: 52.05,
    x2: 219.14,
    y2: 52.05,
    gradientTransform: "translate(25.95 166.76) rotate(-45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f56c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa000"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-6",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-6",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.33
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-6",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-22",
    "data-name": "Degradado sin nombre 88",
    x1: 175.16,
    y1: 215.83,
    x2: 175.16,
    y2: 145.17,
    gradientTransform: "translate(-76.3 176.71) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_87-2",
    "data-name": "Degradado sin nombre 87",
    x1: 175.72,
    y1: 165.58,
    x2: 175.72,
    y2: 217.6,
    gradientTransform: "translate(-86.57 181.43) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_87"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-7",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-7",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.33
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-7",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-23",
    "data-name": "Degradado sin nombre 88",
    x1: 180.18,
    y1: 222.8,
    x2: 215.62,
    y2: 222.8,
    gradientTransform: "translate(-99.58 205.19) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-24",
    "data-name": "Degradado sin nombre 88",
    x1: 234.07,
    y1: 168.91,
    x2: 269.51,
    y2: 168.91,
    gradientTransform: "translate(-45.69 227.51) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-25",
    "data-name": "Degradado sin nombre 88",
    x1: 297.49,
    y1: 183.88,
    x2: 320.09,
    y2: 183.88,
    gradientTransform: "translate(-39.58 272.2) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-8",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-8",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.33
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-8",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_87-3",
    "data-name": "Degradado sin nombre 87",
    x1: 250.53,
    y1: 167.41,
    x2: 250.53,
    y2: 142.98,
    gradientTransform: "translate(-36.46 222.65) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_87"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-9",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-9",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.33
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-9",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_87-4",
    "data-name": "Degradado sin nombre 87",
    x1: 142.21,
    y1: 121.28,
    x2: 70.89,
    y2: 140.08,
    gradientTransform: "translate(-67.97 104.72) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_87"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-10",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-10",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.33
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-10",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-26",
    "data-name": "Degradado sin nombre 88",
    x1: 407.85,
    y1: 420.95,
    x2: 437.71,
    y2: 420.95,
    gradientTransform: "translate(-173.82 422.24) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-27",
    "data-name": "Degradado sin nombre 88",
    x1: 297.87,
    y1: 335.25,
    x2: 312.03,
    y2: 335.25,
    gradientTransform: "translate(-147.74 313.82) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-28",
    "data-name": "Degradado sin nombre 88",
    x1: 332.95,
    y1: 294.78,
    x2: 348.53,
    y2: 294.78,
    gradientTransform: "translate(-108.64 327.28) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-29",
    "data-name": "Degradado sin nombre 88",
    x1: 305.01,
    y1: 378.7,
    x2: 315.75,
    y2: 378.7,
    gradientTransform: "translate(-176.87 330.39) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-30",
    "data-name": "Degradado sin nombre 88",
    x1: 296.37,
    y1: 318.45,
    x2: 307.1,
    y2: 318.45,
    gradientTransform: "translate(-136.8 306.63) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-31",
    "data-name": "Degradado sin nombre 88",
    x1: 340.04,
    y1: 368.87,
    x2: 362.13,
    y2: 368.87,
    gradientTransform: "translate(-158 356.3) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-32",
    "data-name": "Degradado sin nombre 88",
    x1: 357.3,
    y1: 344.75,
    x2: 387.16,
    y2: 344.75,
    gradientTransform: "translate(-134.75 364.18) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-33",
    "data-name": "Degradado sin nombre 88",
    x1: 349.71,
    y1: 415.94,
    x2: 381.87,
    y2: 415.94,
    gradientTransform: "translate(-186.98 380.48) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-34",
    "data-name": "Degradado sin nombre 88",
    x1: 355.42,
    y1: 446.67,
    x2: 367.06,
    y2: 446.67,
    gradientTransform: "translate(-210.04 386.26) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-35",
    "data-name": "Degradado sin nombre 88",
    x1: 338.04,
    y1: 434.02,
    x2: 346.64,
    y2: 434.02,
    gradientTransform: "translate(-206.63 369.2) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-36",
    "data-name": "Degradado sin nombre 88",
    x1: 326.57,
    y1: 379.36,
    x2: 335.17,
    y2: 379.36,
    gradientTransform: "translate(-171.34 345.07) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-37",
    "data-name": "Degradado sin nombre 88",
    x1: 310.06,
    y1: 284.11,
    x2: 318.66,
    y2: 284.11,
    gradientTransform: "translate(-108.82 305.5) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-38",
    "data-name": "Degradado sin nombre 88",
    x1: 138.55,
    y1: 376.4,
    x2: 134.91,
    y2: 383.25,
    gradientTransform: "translate(-1.32 130.86) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-11",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.32,
    dy: 0.32
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-11",
    stdDeviation: 0.22
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.33
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-11",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-39",
    "data-name": "Degradado sin nombre 88",
    x1: 83.52,
    y1: 283.61,
    x2: 134.91,
    y2: 283.61,
    gradientTransform: "translate(114.08 271.5) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-12",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.02,
    dy: 2.02
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-12",
    stdDeviation: 1.35
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.33
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-12",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-40",
    "data-name": "Degradado sin nombre 88",
    x1: 67.89,
    y1: 267.98,
    x2: 91.87,
    y2: 267.98,
    gradientTransform: "translate(175.21 277.43) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-13",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.02,
    dy: 2.02
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-13",
    stdDeviation: 1.35
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.33
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-13",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-41",
    "data-name": "Degradado sin nombre 88",
    x1: 114.21,
    y1: 314.3,
    x2: 138.19,
    y2: 314.3,
    gradientTransform: "translate(63.38 231.11) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-42",
    "data-name": "Degradado sin nombre 88",
    x1: 146.07,
    y1: 284.29,
    x2: 161.09,
    y2: 284.29,
    gradientTransform: "translate(37.87 301.7) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-43",
    "data-name": "Degradado sin nombre 88",
    x1: 188.42,
    y1: 375.15,
    x2: 194.87,
    y2: 375.15,
    gradientTransform: "translate(-91.36 173.52) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-44",
    "data-name": "Degradado sin nombre 88",
    x1: 129.83,
    y1: 328.62,
    x2: 136.28,
    y2: 328.62,
    gradientTransform: "translate(41.56 211.5) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-45",
    "data-name": "Degradado sin nombre 88",
    x1: 187.54,
    y1: 316.37,
    x2: 193.99,
    y2: 316.37,
    gradientTransform: "translate(-48.3 273.23) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-46",
    "data-name": "Degradado sin nombre 88",
    x1: 163.61,
    y1: 364.64,
    x2: 178.62,
    y2: 364.64,
    gradientTransform: "translate(-48.88 176.94) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_87-5",
    "data-name": "Degradado sin nombre 87",
    x1: 173.68,
    y1: 364.24,
    x2: 182.89,
    y2: 364.24,
    gradientTransform: "translate(-60.84 182.68) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_87"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-14",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.67,
    dy: 0.67
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-14",
    stdDeviation: 0.67
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.33
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-14",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_87-6",
    "data-name": "Degradado sin nombre 87",
    x1: 148.8,
    y1: 348.38,
    x2: 158,
    y2: 348.38,
    gradientTransform: "translate(-7.14 192.17) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_87"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-15",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.67,
    dy: 0.67
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-15",
    stdDeviation: 0.67
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.33
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-15",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-47",
    "data-name": "Degradado sin nombre 88",
    x1: 94.86,
    y1: 371.59,
    x2: 94.86,
    y2: 304.78,
    gradientTransform: "translate(100.02 168.24) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_87-7",
    "data-name": "Degradado sin nombre 87",
    x1: 93,
    y1: 307.25,
    x2: 93,
    y2: 356.43,
    gradientTransform: "translate(105.23 171.85) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_87"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-16",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.02,
    dy: -2.02
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-16",
    stdDeviation: 1.35
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.33
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-16",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-48",
    "data-name": "Degradado sin nombre 88",
    x1: 150.56,
    y1: 327.22,
    x2: 184.06,
    y2: 327.22,
    gradientTransform: "translate(-15.93 238.12) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_88-49",
    "data-name": "Degradado sin nombre 88",
    x1: 167.34,
    y1: 264.67,
    x2: 182.14,
    y2: 264.67,
    gradientTransform: "translate(15.61 350.16) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_88"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-17",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.47,
    dy: 0.47
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-17",
    stdDeviation: 0.94
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.33
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-17",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_87-8",
    "data-name": "Degradado sin nombre 87",
    x1: 170.04,
    y1: 351.54,
    x2: 170.04,
    y2: 328.45,
    gradientTransform: "translate(-29.72 218.01) rotate(-45)",
    xlinkHref: "#Degradado_sin_nombre_87"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-18",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.02,
    dy: 2.02
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-18",
    stdDeviation: 1.35
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.33
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-18",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("image", {
    width: 215,
    height: 89,
    transform: "translate(73 190)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 226.76,
    y: 175.13,
    width: 43.06,
    height: 43.06,
    transform: "translate(211.78 -117.97) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.29,
    y: 125.53,
    width: 12.01,
    height: 12.01,
    transform: "translate(170.12 -147.65) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 230.41,
    y: 55.65,
    width: 6.26,
    height: 6.26,
    transform: "translate(109.97 -147.92) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 220.89,
    y: 88.38,
    width: 9.3,
    height: 9.3,
    transform: "translate(131.84 -132.23) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 302.13,
    y: 204.38,
    width: 17.31,
    height: 17.31,
    transform: "translate(241.67 -157.37) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 180.02,
    y: 72.01,
    width: 13.54,
    height: 13.54,
    transform: "translate(110.42 -109.01) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 77.96,
    y: 207.44,
    width: 112.37,
    height: 112.37,
    transform: "translate(225.7 -17.64) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 70.21,
    y: 229.32,
    width: 112.37,
    height: 112.37,
    transform: "translate(238.9 -5.75) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 60.69,
    y: 93.59,
    width: 91.79,
    height: 91.79,
    transform: "translate(129.85 -34.51) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 106.59,
    y: 14.27,
    width: 73.44,
    height: 73.44,
    transform: "translate(78.03 -86.4) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 118.25,
    y: -13.4,
    width: 73.44,
    height: 73.44,
    transform: "translate(61.88 -102.75) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 171.12,
    y: 103.55,
    width: 38.44,
    height: 38.44,
    transform: "translate(142.56 -98.63) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 168.62,
    y: 85.05,
    width: 38.44,
    height: 38.44,
    transform: "translate(128.75 -102.28) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 150.34,
    y: 97.27,
    width: 17.93,
    height: 17.93,
    transform: "translate(121.78 -81.53) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 199.34,
    y: 146.27,
    width: 17.93,
    height: 17.93,
    transform: "translate(170.78 -101.83) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 235.45,
    y: 202.73,
    width: 11.23,
    height: 11.23,
    transform: "translate(217.93 -109.43) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 222.28,
    y: 185.4,
    width: 11.23,
    height: 11.23,
    transform: "translate(201.81 -105.2) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 290.3,
    y: 179.1,
    width: 16.38,
    height: 16.38,
    transform: "translate(219.86 -156.21) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 270.21,
    y: 223.57,
    width: 6.13,
    height: 6.13,
    transform: "translate(240.29 -126.85) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 224.89,
    y: 122.79,
    width: 18.68,
    height: 18.68,
    transform: "translate(162.03 -126.92) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 207.62,
    y: 63.06,
    width: 10.63,
    height: 10.63,
    transform: "translate(411.85 -33.84) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 230.07,
    y: 211.73,
    width: 21.97,
    height: 21.97,
    transform: "translate(228.09 -105.22) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 228.45,
    y: 113.3,
    width: 11.23,
    height: 11.23,
    transform: "translate(152.64 -130.68) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 185.76,
    y: 66.42,
    width: 4.82,
    height: 4.82,
    transform: "translate(103.79 -112.89) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 213.15,
    y: 167.98,
    width: 4.82,
    height: 4.82,
    transform: "translate(183.62 -102.52) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 261.09,
    y: 205.34,
    width: 4.82,
    height: 4.82,
    transform: "translate(224.08 -125.47) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 274.19,
    y: 155.02,
    width: 4.82,
    height: 4.82,
    transform: "translate(192.33 -149.48) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 309.4,
    y: 213.56,
    width: 4.82,
    height: 4.82,
    transform: "translate(244.04 -157.23) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 345.4,
    y: 189.56,
    width: 4.82,
    height: 4.82,
    transform: "translate(237.61 -189.71) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 201.07,
    y: 46.86,
    width: 11.23,
    height: 11.23,
    transform: "translate(97.64 -130.78) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 210.83,
    y: 48.61,
    width: 6.88,
    height: 6.88,
    transform: "translate(99.56 -136.26) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 148.78,
    y: 154.08,
    width: 52.76,
    height: 52.76,
    transform: "translate(178.91 -71) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 156.4,
    y: 175.89,
    width: 38.63,
    height: 38.63,
    transform: "translate(189.5 -67.08) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 185.37,
    y: 210.27,
    width: 25.06,
    height: 25.06,
    transform: "translate(215.51 -74.68) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 239.26,
    y: 156.38,
    width: 25.06,
    height: 25.06,
    transform: "translate(193.18 -128.57) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 300.8,
    y: 175.89,
    width: 15.98,
    height: 15.98,
    transform: "translate(220.46 -164.49) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 242.03,
    y: 146.84,
    width: 17.01,
    height: 17.01,
    transform: "translate(183.22 -131.66) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 47.42,
    y: 89.4,
    width: 90.01,
    height: 90.01,
    transform: "translate(122.11 -25.99) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m18.33,95.17c1.93,0,1.93-3,0-3s-1.93,3,0,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m18.33,95.17c1.93,0,1.93-3,0-3s-1.93,3,0,3h0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 412.22,
    y: 410.39,
    width: 21.11,
    height: 21.11,
    transform: "translate(421.48 -175.66) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 299.94,
    y: 330.24,
    width: 10.01,
    height: 10.01,
    transform: "translate(326.37 -117.44) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 335.73,
    y: 289.77,
    width: 10.01,
    height: 10.01,
    transform: "translate(308.24 -154.6) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 307.09,
    y: 375.4,
    width: 6.59,
    height: 6.59,
    transform: "translate(358.69 -108.55) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 298.44,
    y: 315.15,
    width: 6.59,
    height: 6.59,
    transform: "translate(313.55 -120.09) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 343.27,
    y: 361.06,
    width: 15.63,
    height: 15.63,
    transform: "translate(363.66 -140.21) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 361.67,
    y: 334.2,
    width: 21.11,
    height: 21.11,
    transform: "translate(352.8 -162.23) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 354.42,
    y: 404.57,
    width: 22.74,
    height: 22.74,
    transform: "translate(401.25 -136.83) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 357.12,
    y: 442.56,
    width: 8.23,
    height: 8.23,
    transform: "translate(421.65 -124.61) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 339.3,
    y: 430.98,
    width: 6.08,
    height: 6.08,
    transform: "translate(407.17 -114.95) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 327.83,
    y: 376.32,
    width: 6.08,
    height: 6.08,
    transform: "translate(365.16 -122.85) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 311.32,
    y: 281.07,
    width: 6.08,
    height: 6.08,
    transform: "translate(292.97 -139.07) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 427.65,
    y: 335.62,
    width: 86.77,
    height: 86.77,
    transform: "translate(536.1 980.07) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 357.7,
    y: 295.02,
    width: 11.14,
    height: 11.14,
    transform: "translate(407.59 770.02) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 355.93,
    y: 299.22,
    width: 11.14,
    height: 11.14,
    transform: "translate(401.61 775.93) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 373.68,
    y: 376.64,
    width: 36.34,
    height: 36.34,
    transform: "translate(389.76 951.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 376.04,
    y: 394.13,
    width: 36.34,
    height: 36.34,
    transform: "translate(381.42 982.59) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 412.71,
    y: 401.96,
    width: 16.95,
    height: 16.95,
    transform: "translate(428.78 998.49) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 366.39,
    y: 355.64,
    width: 16.95,
    height: 16.95,
    transform: "translate(382.46 886.65) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 351.04,
    y: 324.99,
    width: 10.62,
    height: 10.62,
    transform: "translate(374.77 815.83) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 327.71,
    y: 406.15,
    width: 10.73,
    height: 10.73,
    transform: "translate(277.6 938.01) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 342.72,
    y: 372.49,
    width: 17.66,
    height: 17.66,
    transform: "translate(330.49 899.53) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 365.46,
    y: 441.21,
    width: 10.05,
    height: 10.05,
    transform: "translate(-207.02 392.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 342.18,
    y: 388.82,
    width: 10.62,
    height: 10.62,
    transform: "translate(314.5 918.53) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 307.14,
    y: 300.99,
    width: 4.56,
    height: 4.56,
    transform: "translate(313.76 736.51) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 365.73,
    y: 347.52,
    width: 4.56,
    height: 4.56,
    transform: "translate(380.9 857.36) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 308.02,
    y: 359.77,
    width: 4.56,
    height: 4.56,
    transform: "translate(273.71 837.47) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 324.64,
    y: 308.47,
    width: 10.62,
    height: 10.62,
    transform: "translate(341.38 768.97) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 319.53,
    y: 310.92,
    width: 6.51,
    height: 6.51,
    transform: "translate(328.86 764.57) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 344.41,
    y: 326.79,
    width: 6.51,
    height: 6.51,
    transform: "translate(360.13 809.25) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 381.27,
    y: 315.33,
    width: 49.88,
    height: 49.88,
    transform: "translate(452.83 868.11) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 389.8,
    y: 324.89,
    width: 36.52,
    height: 36.52,
    transform: "translate(453.96 874.34) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 321.91,
    y: 339.35,
    width: 23.69,
    height: 23.69,
    transform: "translate(321.43 835.53) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 321.09,
    y: 408.52,
    width: 10.47,
    height: 10.47,
    transform: "translate(264.5 937.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 322.99,
    y: 330.25,
    width: 16.08,
    height: 16.08,
    transform: "translate(325.9 811.56) rotate(-135)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardbg);
export default __webpack_public_path__ + "static/media/cardbg.0bd56feb7bfbbcfbffa185d7dc1d19ba.svg";
export { ForwardRef as ReactComponent };